import 'bootstrap/dist/css/bootstrap.css';
import AppRoutes from './appRoutes';

require('./app.css');
require('./toggle-chat.css');

export default function App() {
  return (<AppRoutes/>);
}
